class jfAboutBox {
    constructor($scope, $timeout, XRayUIState, JFrogNotifications, XRayUtils, JFrogEventBus, ComponentsDao, JFrogTableViewOptions, User, $window, JFrogModal, $state, CompLicensesDao, xrayLicensesDao) {
        this.jFrogNotifications = JFrogNotifications;
        this.user = User;
        this.XRayUIState = XRayUIState;
        this.compLicensesDao = CompLicensesDao
        this.ComponentsDao = ComponentsDao;
        this.TemplateGenerator = JFrogTableViewOptions.cellTemplateGenerators;
        this.tableViewOptions = new JFrogTableViewOptions($scope);
        this.licenseTableViewOptions = new JFrogTableViewOptions($scope);
        this.unknownTableViewOptions = new JFrogTableViewOptions($scope);
        this.$timeout = $timeout;
        this.$state = $state;
        this.$window = $window;
        this.xrayUtils = XRayUtils;
        this.jfrogEventBus = JFrogEventBus;
        this.EVENTS = JFrogEventBus.getEventsDefinition();
        this.$scope = $scope;
        this.aboutBoxType = "licensed";
        this.modal = JFrogModal;
        this.excludeUnknown = true;
        this.headers = {
            known: "Discovered Licenses",
            unknown: "Unknown Licenses"
        }

        this.xrayLicensesDao = xrayLicensesDao;
        this.jfrogEventBus = JFrogEventBus;
        this._getLicensesList();

        let removeUpdateListener = JFrogEventBus.register(this.EVENTS.COMPONENT_VERSION_SELECTED, () => {
            this.init();
        });

        this.$timeout(() => {

            this.$scope.$on('$destroy', () => {
                removeUpdateListener();
            });
        }, 500);

    }

    _getLicensesList() {
        this.xrayLicensesDao.getNames().$promise.then((licenses) => {
            licenses.shift();
            this.constLicenseList = _.cloneDeep(licenses);
        });
    }

    $onInit() {
        this.init()
    }

    showAboutBoxModal() {
        let modalScope = this.$scope.$new();

        let options = {windowClass: 'aboutbox-modal'};
        this.modal.launchModal('download_aboutbox_modal', modalScope, 'lg', true, options).result.then((response) => {


        });
    }

    deleteCustomLicense(row) {

        let selectedLicensedComp = _.find(this.LicensesDictionary, {
            component_id: row.component_id
        }).licenses;
        let customLicenses = _.map(_.filter(selectedLicensedComp, (l) => {
            return _.findIndex(l.sources, {source: "Custom"}) > -1;
        }), 'key');
        let version = "";

        if (row.version !== '') {
            version = ":" + row.version;
        }

        let params = {
            component_id: row.package_id + version
        }

        if (customLicenses.length == 1) {
            params.license = customLicenses[0];
            console.log("Row is", row)
            this.modal.confirm(`Are you sure you want to remove custom license <strong>(${params.license})</strong> from <strong>${row.component_name} </strong>  ?`)
                .then(() => {
                    console.log("Calling remove api");
                    this.callRemoveLicApi(row, params, params.license)
                });
        } else {

            let modalScope = this.$scope.$new();
            modalScope.lisencesList = customLicenses;
            modalScope.selectedLicense = null;
            let options = {windowClass: 'remove-custom-modal'};
            this.modal.launchModal('show_remove_custom_modal', modalScope, 'lg', true, options).result.then((response) => {
                console.log("MODAL RESPNSE", response)
                params.license = response;
                this.callRemoveLicApi(row, params, params.license)
            });
        }
    }

    callRemoveLicApi(row, params, customLicenses) {

        row.licenses.splice(_.findIndex(row.licenses, customLicenses), 1)
        this.compLicensesDao.deleteLicense(params).$promise.then(() => {
            console.log('row is', row);
            if (row.licenses && row.licenses.length == 0) {
                this.unknownLicensed.push(row);
                this.knownLicensed.splice(_.findIndex(this.knownLicensed, {"component_id": row.component_id}), 1);
                row.sources = ["JFrog"];
            }
            this.getAboutBoxData();
            this.tableViewOptions.update();
            this.unknownTableViewOptions.update();
            this.headers.known = `Known Licenses (${this.knownLicensed.length})`;
            this.headers.unknown = `Unknown Licenses (${this.unknownLicensed.length})`;
            this.$timeout(() => {
                console.log(" ** Dispatching ** ")
                this.jfrogEventBus.dispatch(this.EVENTS.CUSTOM_ISSUE_ADDED);
            }, 500)

        });
    }

    downloadAboutBox(formatType = 'csv') {


        let qParams;
        let token = this.user["XRayUIState"].states.sessionData.token;
        if (this.componentId.split('://')[0] == 'generic') {

            qParams = {
                compName: this.componentId.split('//')[1].split('/')[1],
                prefix: 'generic',
                sha: this.componentId.split('//')[1].split('/')[0]
            }
            qParams.format = formatType;
            qParams.excludeUnknown = !this.excludeUnknown;
            console.log("Downloading File from: " + "/ui/component/exportAboutBox?token=" + token + '&prefix=' + qParams.prefix + '&compName=' + qParams.compName + '&format=' + qParams.format + '&excludeUnknown=' + qParams.excludeUnknown);

            this.$window.open("/ui/component/exportAboutBox?token=" + token + '&prefix=generic&sha=' + qParams.sha + '&compName=' + qParams.compName + '&format=' + qParams.format + '&excludeUnknown=' + qParams.excludeUnknown, "_self");

        } else {
            qParams = {
                compName: this.componentId.split('://')[1],
                prefix: this.componentId.split('://')[0]
            }
            qParams.excludeUnknown = !this.excludeUnknown;
            qParams.format = formatType;
            console.log("Downloading File from: " + "/ui/component/exportAboutBox?token=" + token + '&prefix=' + qParams.prefix + '&compName=' + qParams.compName + '&format=' + qParams.format + '&excludeUnknown=' + qParams.excludeUnknown);

            this.$window.open("/ui/component/exportAboutBox?token=" + token + '&prefix=' + qParams.prefix + '&compName=' + qParams.compName + '&format=' + qParams.format + '&excludeUnknown=' + qParams.excludeUnknown, "_self");

        }
    }


    createGrid() {
        this.tableViewOptions.setId('overview-table')
            .setObjectName('Component/Components')
            .setColumns(this.getColumns())
            .setActions(this.getKnownActions())


        this.unknownTableViewOptions.setId('unknown-table')
            .setObjectName('Component/Components')
            .setBatchActions(this.getBatchActions())
            .setColumns(this.getUnknownColumns())
            .setRowsPerPage(10)
            .setActions(this.getActions())

        this.tableViewOptions.emptyTableText = 'No licenses found for current component';
        this.unknownTableViewOptions.emptyTableText = 'No Unknown licenses found for current component';

        this.licenseTableViewOptions.setId('license-table')
            .setObjectName('License/Licenses')
            .setColumns(this.getLicenseViewColumns())
            .setRowsPerPage(10)

        this.licenseTableViewOptions.noCount = this.tableViewOptions.noCount = this.unknownTableViewOptions.noCount = true;

    }

    getBatchActions() {
        return [
            {
                icon: 'icon icon-report',
                name: 'Assign License',
                callback: () => {
                    let selected = this.unknownTableViewOptions.getSelectedRows();
                    let fixedArr = this._pickFields(selected, ['package_id', 'pkg_type', 'version', 'component_name']);
                    this.setBulkCustomLicense(fixedArr)
                }
            }
        ]
    };

    _pickFields(data, arrOfFields) {
        return _.map(data, _.partial(_.ary(_.pick, 2), _, arrOfFields));
    }

    getColumns(origin = "known") {
        let licHeader = `<div>Licenses <i  jf-tooltip="{{'Aggregate by License'}}" ng-click="appScope.jfAboutBox._setCompByLicenseArr()" class="jf-link download-aboutbox icon icon-group"> </i> </div>`;
        if (origin !== "known") {

            licHeader = "<div>Licenses</div>";

        }

        let cols = [

            {
                "header": "Component",
                "field": "component_id",
                "cellTemplate": `<div ng-click="appScope.jfAboutBox.goToComp(row.entity.package_id,row.entity.version)"
                class="{{row.entity.priority}}"><a class="jf-link" >
                <i jf-tooltip="{{appScope.jfAboutBox.getPackageName(row)}}" style="text-align:center;margin-right:10px"
                class="no-cm-action sample-table-icon icon icon-{{row.entity.pkg_type}}">
                </i> <span class="jf-link" >{{row.entity.component_name}}</span></a></div>`,
                "filterable": true,
                "width": "30%"
            },
            {
                "header": "Version",
                "field": "version",
                "cellTemplate": `<div ng-if="row.entity.version !=''">{{row.entity.version}}</div><div ng-if="row.entity.version ==''">N/A</div>`,
                "width": "15%"

            },
            {
                "headerCellTemplate": licHeader,
                "header": "Licenses",
                'field': 'licenses',
                "cellTemplate": this.listableColumn('row.entity.licenses', 'row.entity.component_id'),
                "width": "55%"
            }
        ];
        return cols;
    }

    getTooltip(row, lic) {
        //console.log("Need to show tooltip for",row.entity);
        let component_id = row.entity.component_id;
        let selectedLicSources = [];
        if(_.find(this.LicensesDictionary, {component_id})){
            selectedLicSources = _.map(_.find(_.find(this.LicensesDictionary, {component_id}).licenses, {key: lic}).sources,"source")
        }

        let resourcesText = `Resources:<br/>${selectedLicSources.join('<br/>')}`

        return resourcesText
    }


    listableColumn(listModel, rowNameModel, displayModel, alwaysShow, testIdPrefix = null, showAsyncData, externalCountModel) {
        let nextId = 0;
        testIdPrefix = testIdPrefix ? testIdPrefix + '-' : '';

        displayModel = displayModel ? `{{${listModel}.length}} | {{${displayModel}}}` : `{{${externalCountModel} ? ${externalCountModel} : ${listModel}.length}} |  {{${externalCountModel} && ${externalCountModel} > ${listModel}.length ? ',...' : ''}}`;

        let id = `${testIdPrefix}{{row.uid}}_${nextId}`;

        let template = `<div><div ng-if="${listModel}.length"
                                   ng-class="{'always-show': ${showAsyncData} || ${alwaysShow} }"
                                   class="ui-grid-cell-contents no-tooltip" id="${id}">
                                <span class="gridcell-content-text">  ${displayModel}  <span> <a style="margin-right:5px" class="jf-link" ng-repeat="lic in row.entity.licenses" jf-tooltip="{{grid.appScope.jfAboutBox.getTooltip(row,lic)}}" ng-click="grid.appScope.jfAboutBox.buildLinks(lic)">  <span ng-if="!$last">{{lic}},  </span><span ng-if="$last">{{lic}}</span> </a></span></span>
                                 <a class="gridcell-showall" ng-if="!(${showAsyncData}) && (table.options.isOverflowing('${testIdPrefix}'+row.uid+'_'+${nextId}) || ${alwaysShow})" href ng-click="table.options.showAll(${listModel},${rowNameModel},col);$event.stopPropagation()"> (See All)</a>
                                 <a class="gridcell-showall" ng-if="${showAsyncData}" href ng-click="table.options.asyncShowAll(${rowNameModel},col)"> (See All)</a>
                             </div>
                             <div ng-if="!${listModel}.length" class="ui-grid-cell-contents no-tooltip" id="${id}">-</div></div>`;

        nextId++;
        return template;
    }

    buildLinks(model) {
        this.$scope.$parent.ctrl.assignCustomLicense(model, 'aboutbox-view').then((response) => {


        });
    }

    getUnknownColumns() {
        return [

            {
                "header": "Component",
                "field": "component_id",
                "cellTemplate": `<div ng-click="appScope.jfAboutBox.goToComp(row.entity.package_id,row.entity.version)" class="{{row.entity.priority}}"><a class="jf-link"><i jf-tooltip="{{appScope.jfAboutBox.getPackageName(row)}}" style="text-align:center;margin-right:10px" class="no-cm-action sample-table-icon icon icon-{{row.entity.pkg_type}}"></i> {{row.entity.component_name}}</a></div>`,
                "filterable": true
            },
            {
                "header": "Version",
                "field": "version",
                "cellTemplate": `<div ng-if="row.entity.version !=''">{{row.entity.version}}</div><div ng-if="row.entity.version ==''">N/A</div>`
            }

        ];
    }

    getPackageName(row) {

        return this.xrayUtils.getPackageByPrefix(row.entity.package_id.split("://")[0]);
    }

    getLicenseViewColumns() {

        let licHeader = `<div>Licenses <i  jf-tooltip="{{'Hide Grid'}}" ng-click="appScope.jfAboutBox.hideAggregated()" class="jf-link download-aboutbox icon icon-group"> </i> </div>`;

        return [
            {
                "header": "Component",
                "field": "component_id",
                'cellTemplate': `<div> <a ng-click="appScope.jfAboutBox.goToComp(row.entity.package_id,row.entity.version)"  class="jf-link">{{row.entity.component_id}}</a></div>`,
                "filterable": true
            },
            {
                "headerCellTemplate": licHeader,
                "header": "Licenses",
                'field': 'license',
                'cellTemplate': `<div ><a >{{row.entity.license}}</a></div>`,
                "filterable": true
            }
            /*{
                "header": "Author",
                "field": "author",
                "cellTemplate": `<div ng-click="appScope.ctrl.testAppScope()" class="{{row.entity.author}}">{{row.entity.author}}</div>`,
                /!* "headerCellTemplate": `<div>{{col.header}} ({{appScope.ctrl.runningId}})</div>`,*!/
                "allowGrouping": true,
                "pixelWidthThreshold": 200
            },
            {
                "header": "Modified",
                'field': 'modified',
                "cellTemplate": `<div ng-click="appScope.ctrl.testAppScope()" class="">{{row.entity.modified | date:'medium'}}</div>`,
                "pixelWidthThreshold": 170,
                "filterable": true
            }*/
        ]
    }

    hideAggregated() {
        this.licenseGridReady = false;
    }

    getActions() {
        return [
            {
                icon: 'icon icon-report',
                tooltip: 'Assign Custom License',
                callback: (row) => {
                    this.setCustomLicense(row)
                },
                visibleWhen: (row) => {
                    return row.licenses[0] == 'Unknown'
                }
            }
        ];
    }

    getKnownActions() {
        return [
            {
                icon: 'icon icon-clear',
                tooltip: 'Remove Custom License',
                callback: (row) => {
                    this.deleteCustomLicense(row)
                },
                visibleWhen: (row) => {
                    return _.includes(row.sources, 'Custom');
                }
            }
        ];
    }

    setCustomLicense(row) {
        this.$scope.$parent.ctrl.assignCustomLicense(row, 'aboutbox').then((response) => {

            this.updateLicense(row, response);
        })
    }

    setBulkCustomLicense(row) {
        this.$scope.$parent.ctrl.assignCustomLicense(row, 'aboutbox-bulk').then((response) => {

            //this.updateLicense(row, response);
        })
    }


    updateLicense(row, license) {

        this.unknownLicensed.splice(_.findIndex(this.unknownLicensed, {"component_id": row.component_id}), 1);
        this.unknownTableViewOptions.setData(this.unknownLicensed);
        row.licenses = [license.name];
        row.sources = ["Custom"]
        this.knownLicensed.push(row)


        this.tableViewOptions.update()
        this.headers.known = `Known Licenses (${this.knownLicensed.length})`;
        this.headers.unknown = `Unknown Licenses (${this.unknownLicensed.length})`;
    }

    refreshGrid() {

        this.$timeout(() => {
            this.unknownTableViewOptions.update();
        })
    }

    init() {

        this.$timeout(()=>{
            this.createGrid()
            this.getAboutBoxData()
        })

    }

    getAboutBoxData() {
        this.ComponentsDao.getAboutBox({component_id: this.componentId}).$promise.then((resp) => {
            this.fetchInProgress = true;
            this.LicensesDictionary = _.cloneDeep(resp)
            this.originalAboutBoxResponseByComp = _.cloneDeep(resp);
            _.each(this.originalAboutBoxResponseByComp, (row) => {
                row.sources = [];
                _.each(row.licenses, (val) => {

                    row.sources.push(_.map(val.sources, "source"))
                })
                row.sources = _.flattenDeep(row.sources)
                row.licenses = _.map(row.licenses, 'key')

            });

            this.unknownLicensed = _.filter(this.originalAboutBoxResponseByComp, (obj) => {
                return obj.licenses.indexOf('Unknown') > -1;
            });

            this.knownLicensed = _.filter(this.originalAboutBoxResponseByComp, (obj) => {
                return obj.licenses.indexOf('Unknown') < 0;
            });

            this.tableViewOptions.setData(this.knownLicensed);
            this.unknownTableViewOptions.setData(this.unknownLicensed);
            this.uniqueLicensesList = _.uniq(_.map(_.flattenDeep(_.map(resp, 'licenses')), 'key'));

            if (this.uniqueLicensesList && this.uniqueLicensesList.indexOf('Unknown') > -1) {
                this.uniqueLicensesList.splice(this.uniqueLicensesList.indexOf('Unknown'), 1);
            }

            this.XRayUIState.setState("fetchingAboutBox", false);
        });
    }

    goToComp(componentID, componentVersion) {
        if (componentID) {
            this.$state.go('components.details', {componentID, componentVersion});
        }
    }

    _setCompByLicenseArr(force = false) {

        if (this.licenseGridReady) {
            return;
        }
        this.licenseTableViewOptions.setData([])
        if (!this.licenseGridReady) {
            let allComps = _.map(_.cloneDeep(this.knownLicensed), (element) => {
                return _.extend({}, element, {numOfMatch: 0});
            });

            let uniqueLicenses = _.cloneDeep(this.uniqueLicensesList);
            let compByLicense = [];
            _.each(uniqueLicenses, (license) => {
                _.each(allComps, (val, key) => {
                    if (val.numOfMatch == val.licenses.length) {
                        return;
                    }
                    if (val && val.licenses.indexOf(license) > -1) {
                        val.numOfMatch++;
                        compByLicense.push({
                            component_id: val.component_id,
                            license: license,
                            version: val.version,
                            package_id: val.package_id
                        })
                    }
                });
            });
            this.compByLicense = compByLicense
            this.licenseTableViewOptions.setData(compByLicense);
            this.licenseGridReady = true;
            if (!this.isGrouped) {
                this.isGrouped = true;
                this.licenseTableViewOptions.groupBy('license');
            }
        }

        //switch that will show the license grid

        //this.licenseTableViewOptions.setPaginationMode(this.licenseTableViewOptions.VIRTUAL_SCROLL);

    }

    licenseCriteriaChanged() {
        if (this.aboutBoxType == "licensed") {
            this.tableViewOptions.setData(this.knownLicensed);
        } else {
            this.tableViewOptions.setData(this.unknownLicensed);
        }
    }
}

export function jfAboutBox() {

    return {
        restrict: 'E',
        scope: {
            $dismiss: '&',
            $close: '&',
            componentId: '='
        },
        controller: jfAboutBox,
        controllerAs: 'jfAboutBox',
        template: require('./jf_about_box.html'),
        bindToController: true
    };
}




// WEBPACK FOOTER //
// ./modules/xray/directives/jf_about_box/jf_about_box.js